<div class="card">
    <div class="card-body">
        <div class="row mb-2">
            <div class="col-6">
                <h5 class="mt-0 mb-2">
                    Educación
                </h5>
            </div>
            <div class="col-6">
                <div class="text-end">
                    <button type="button" (click)="add()" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#modalEducation">
                        <i class="fa-regular fa-square-plus"></i>
                        Nuevo
                    </button>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-2">
            <table class="table table-hover table-theme">
                <thead>
                    <tr>
                        <th>Institución</th>
                        <th>Nivel Académico</th>
                        <th>Estudios Realizados</th>
                        <th>Estatus</th>
                        <th>Fecha de inicio</th>
                        <th>Fecha de fin</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of educations(); let index = $index; track $index; ) {
                        <tr>
                            <td class="text-left">{{item.institution}}</td>
                            <td class="text-left">{{item.educationLevel}}</td>
                            <td class="text-left">{{item.career}}</td>
                            <td class="text-left">{{item.resumeEducationStatus}}</td>
                            <td class="text-left">{{item.startDate | date : 'dd/MM/yyyy'}}</td>
                            <td class="text-left">{{item.endDate | date : 'dd/MM/yyyy'}}</td>
                            <td class="text-center">
                                <button (click)="editResumeEducation(item, index)" type="button" class="btn btn-outline-success me-2"
                                data-bs-toggle="modal" data-bs-target="#modalEducation">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </button>
                                <button (click)="deleteResumeEducation(item, index)" type="button" class="btn btn-outline-danger">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>


    </div>
</div>

<app-modal-education
[resumeId]="resumeId()"
(onResumeEducation)="handlerResumeEducation($event)"/>